<form [formGroup]="formGroupZugangsdaten()">
  <p class="paragraph_small">{{'registrierung.zugangsdaten.benutzername_gleich_email'|translate}}</p>
  <div class="flex-container">
    <div style="flex: 12">
      <label>{{'registrierung.zugangsdaten.label_benutzername'|translate}}</label>
      <mat-form-field>
        <input matInput formControlName="benutzername" placeholder="{{'registrierung.zugangsdaten.label_benutzername'|translate}}" />
        @if ((formGroupZugangsdaten().touched || formGroupZugangsdaten().dirty) && formGroupZugangsdaten().controls['benutzername'].errors
          ) {
          <mat-error>
            <mat-icon svgIcon="basics:error"></mat-icon>
            <span>{{'registrierung.zugangsdaten.benutzername_ungueltig'|translate}}</span>
          </mat-error>
        }
      </mat-form-field>
    </div>
  </div>
  <div class="flex-container">
    <div style="flex: 12">
      <label>{{'registrierung.zugangsdaten.label_passwort'|translate}}</label>

      <mat-form-field>
        <input [type]="showpassWort() ? 'text' : 'password' " matInput formControlName="passwort"
               placeholder="{{'registrierung.zugangsdaten.label_passwort'|translate}}" />
        <mat-icon matSuffix (click)="onShowPasswortToggle()" [svgIcon]="showpassWort() ? 'basics:view-on' : 'basics:view-off'"></mat-icon>
        @if ((formGroupZugangsdaten().touched || formGroupZugangsdaten().dirty) && formGroupZugangsdaten().controls['passwort'].errors
          ) {
          <mat-error>
            <mat-icon svgIcon="basics:error"></mat-icon>
            <span>{{'registrierung.zugangsdaten.passwort_hinweis'|translate}}</span>
          </mat-error>
        }
        <div class="passwortstaerke">
          @if(passwortstaerke() < 5) {
            <mat-progress-bar mode="determinate" [value]="passwortstaerke() * 20" color="warn"></mat-progress-bar>
          } @else if(passwortstaerke() === 5) {
            <mat-progress-bar mode="determinate" [value]="passwortstaerke() * 20" class="success-color" ></mat-progress-bar>
          }
        </div>
      </mat-form-field>

      <div class="starkes_passwort_generieren">
        <a (click)="generierePasswort(10)" >{{'registrierung.zugangsdaten.passwort_generieren'|translate}}</a>
      </div>

    </div>
  </div>
</form>
